import ChipInputGroup from './ChipInputGroup'

export default ChipInputGroup
